import { styled } from '@creditas/stylitas'
import { prop, ifProp, theme as themeTool } from 'styled-tools'

interface Props {
  endCol: number
  endRow?: number
  startCol: number
  startRow?: number
  verticalCenter?: boolean
}

const GridItem = styled.div<Props>`
  width: 100%;
  grid-column-start: ${({ startCol }): number => startCol};
  grid-column-end: ${({ endCol }): number => endCol};

  ${ifProp('verticalCenter', 'align-self: center;')}
  ${ifProp('startRow', `height: 100%;grid-row-start: ${prop('startRow')};`)}
  ${ifProp('endRow', `grid-row-end: ${prop('endRow')};`)}

  ${themeTool('mediaScreen.tablet')} {
    margin-bottom: 16px;
  }
`

export { GridItem }
